import {AxiosError} from 'axios';
import {PaginatedData} from 'web-library/models/List';
import {ApiPathParam} from 'web-library/models/SearchParamSchema';
import {POST_DATA_ARCHIVAL_REPORT_LISTING_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PORTAL_TYPE} from "../../constants/constantValues";
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

interface Input {
  onSuccess?: (data: PaginatedData<DataArchivalReportEntry>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

interface Payload {
  examYear: string | "";
  examLevels: string[];
  apiPathParam: ApiPathParam;
}


interface DataArchivalReportEntry {
  fileUuid: string;
  fileName: string,
  reportType: string,
  examYear: string;
  examLevel: string;
}

// =============================================================================
// Mutation
// =============================================================================
export const usePostDataArchivalReportListing = ({onSuccess, onError}: Input) => {
  const postDataArchivalReportListing = async (payload: Payload) => {
    const res = await axiosClient.post<PaginatedData<DataArchivalReportEntry>>(
        POST_DATA_ARCHIVAL_REPORT_LISTING_URL(payload.apiPathParam),
        {
          portalType: PORTAL_TYPE,
          examYear: payload.examYear,
          examLevels: payload.examLevels,
        }
    );
    return res.data;
  };

  return useCustomMutation(postDataArchivalReportListing, {
    onSuccess,
    onError,
  });
};
